export default __webpack_public_path__ + "static/media/90t.0f94fdb4.jpg";